import React, { useMemo } from 'react';
import { QueueKey } from 'flow/types/EntityKeys';
import { useAppSelector } from 'flow/hooks/useRedux';

import { getQueueMembersSoonLoggedInThreshold } from 'flow/selectors/supervisor-selectors';
import { makeSelectQueueMembersSoonLoggedIn } from 'flow/selectors/SupervisorSelectors';
import useAppContext from 'flow/hooks/useAppContext';
import BarItemsInfo from 'flow/components/pbx/supervisor/QueueRow/BarItemsInfo';
import SupervisorBarAgentSoonLoggedIn from 'flow/components/pbx/supervisor/SupervisorBarAgentSoonLoggedIn';

interface Props {
    queueKey: QueueKey;
}

const SectionAgentsSoonLoggedIn = ({ queueKey }: Props) => {
    const { i18next } = useAppContext();
    const selectAgentsSoonLoggedIn = useMemo(
        makeSelectQueueMembersSoonLoggedIn,
        [],
    );

    const agentsSoonLoggedIn = useAppSelector((state) =>
        selectAgentsSoonLoggedIn(state, queueKey),
    );

    const agentsSoonLoggedInSorted = useMemo(
        () =>
            agentsSoonLoggedIn
                .sortBy((agent) => agent.get('currentProfileActiveUntil'))
                .slice(0, 100),
        [agentsSoonLoggedIn],
    );

    const threshold = useAppSelector(getQueueMembersSoonLoggedInThreshold);

    return (
        <div className="flex h-4 w-full cursor-default flex-row gap-1.5">
            <BarItemsInfo
                tooltipLabel={i18next.t(
                    'Supervisor.QueueRow.Tooltip.Label.BackSoon',
                )}
                icon={'timelapse'}
                number={agentsSoonLoggedIn?.size}
            />
            <div className="flex items-center gap-x-px overflow-x-auto">
                {agentsSoonLoggedInSorted &&
                !agentsSoonLoggedInSorted.isEmpty() ? (
                    agentsSoonLoggedInSorted
                        .map((agent) => (
                            <SupervisorBarAgentSoonLoggedIn
                                agentKey={agent.get('extensionKey')}
                                key={`sbasli-${agent.get('extensionKey')}`}
                                threshold={threshold}
                            />
                        ))
                        .toArray()
                ) : (
                    <span className="text-xs text-gray-400 dark:text-gray-800">
                        {i18next.t('Supervisor.QueueRow.NoOneBackSoon')}
                    </span>
                )}
            </div>
        </div>
    );
};

export default SectionAgentsSoonLoggedIn;
